import axios, { type AxiosInstance, type AxiosResponse } from 'axios'

type TokenProvider = () => Promise<string>

export const errorInterceptor = (tokenProvider: TokenProvider) => {
  return async (error: unknown): Promise<AxiosResponse> => {
    if (axios.isAxiosError(error) && error.response?.status === 403) {
      // if we catch a 403 error, try to refresh the auth token
      console.warn('[API][ResponseInterceptor] Got 403, refreshing token.')
      const accessToken = await tokenProvider()

      // and retry the initial request with the refreshed token
      const { config: requestConfig } = error
      requestConfig.headers.Authorization = `Bearer ${accessToken}`

      return axios.request(requestConfig)
    }

    return Promise.reject(error)
  }
}

export const registerErrorInterceptor = (
  $axios: AxiosInstance,
  tokenProvider: TokenProvider
): void => {
  $axios.interceptors.response.use(
    (response) => response,
    errorInterceptor(tokenProvider)
  )
}
